import { usePage } from '@/components/providers/PageProvider'

import { FilterInputTypeahead } from '../FilterInputTypeahead/FilterInputTypeahead'

type Props = {
  size?: 'sm'
}

export const FilterInputPreconCommander = (props: Props) => {
  const { page } = usePage()

  const route = page?.route
  const preconCommanders = page?.optionsFilters?.preconCommanders

  if (!preconCommanders) return null

  const preconCommanderSelected =
    preconCommanders.find((option) => option.slug === route?.preconCommanderSlug) || preconCommanders[0]

  return (
    <FilterInputTypeahead
      {...props}
      filter='preconCommanderSlug'
      label='Precon Commanders'
      optionSelected={preconCommanderSelected}
      options={preconCommanders}
    />
  )
}
